var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-10 mt-20 md:my-20"},[_c('e-section-title',{attrs:{"title":_vm.title,"sub-title":_vm.subTitle}}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }